import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import { initLenis } from "@/lib/scroll";
import { NoiseOverlay } from "@/components/NoiseOverlay";
import { BookingModal } from "@/components/BookingModal";
import { Home } from "@/pages/Home";
import { Pitch } from "@/pages/Pitch";

function App() {
    useEffect(() => initLenis(), []);

    return (
        <BrowserRouter>
            <div className="min-h-screen bg-[#050505] text-white antialiased">
                <NoiseOverlay />
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/pitch" element={<Pitch />} />
                </Routes>
                <BookingModal />
            </div>
        </BrowserRouter>
    );
}

export default App;
